// extracted by mini-css-extract-plugin
export default {"container":"instagramFeed-module--container--3YDwe","title":"instagramFeed-module--title--2JWLA","user":"instagramFeed-module--user--3wz2i"};